const CUSTOMER_PAYROLL_STATUS = {
  PENDING: "pending",
  FAILED: "failed",
  PAID: "paid",
  UNPAID: "un-paid",
};

export default CUSTOMER_PAYROLL_STATUS;
